var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{ref:"formLable",attrs:{"prop":_vm.prop,"label":_vm.label,"label-width":_vm.labelWidth,"required":_vm.required,"rules":_vm.rules,"error":_vm.error,"show-message":_vm.showMessage,"inline-message":_vm.inlineMessage,"size":_vm.size}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }